import React from "react";
import ShortAnalyticChartItem from "./short-analytic-chart-item";
import ShortAnalyticMobileChartItem from "./short-analytic-mobile-chart-item";
import { ArrowUp, ArrowDown } from "commons/icon-contols";
import moment from "moment";

class ShortAnlayticChartItemController extends React.Component{
  
    constructor(props){
        super(props);
        this.state = {
            data: props.data,
            deviceType: props.deviceType,
            language: props.language
        }
    }

    componentDidMount(){
        if(this.props.topicIds){
            this.props.getShortAnalytic(this.props.topicIds, this.props.mediaType)
        }
    }

    shouldComponentUpdate(nextProps, nextState){
        
        if((nextProps.data && (nextProps.data.topicId !== nextState.data.topicId)) || nextProps.deviceType !== nextState.deviceType || nextProps.language !== nextState.language){
            this.setState({
                data: nextProps.data,
                deviceType: nextProps.deviceType,
                language: nextProps.language
            })
            return true
        }
        else return false
    }

    getArrowByValues = (prev, now, size=null, color=null) => {
        return prev < now ? <ArrowUp fontSize={size} color={color}/> : <ArrowDown fontSize={size} color={color}/>;
    }

    getFormattedCount = (num) =>{
        return Math.abs(num) > 999 
            ? (Math.abs(num) > 999999 
                ? Math.sign(num)*((Math.abs(num)/1000000).toFixed(1)) + 'KK' 
                : Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'K')
            : Math.sign(num)*Math.abs(num)
    }

    getMoreOrLessByCount = (numFoundWeek, numFoundPrevWeek) => {
        if(numFoundWeek > numFoundPrevWeek){
            return this.props.getValue('DOCUMENTS_COLLECTED_ON')+' '+(numFoundWeek - numFoundPrevWeek)+this.props.getValue('MORE')+" "+this.props.getValue('THAN_THE_PREVIOUS_WEEK');
        }
        else if(numFoundWeek == numFoundPrevWeek){
            return this.props.getValue('DOCUMENTS_COLLECTED')+' '+this.props.getValue('SAME_AMOUNT')+" "+this.props.getValue('LIKE_LAST_WEEK');
        }
        else
            return this.props.getValue('DOCUMENTS_COLLECTED_ON')+' '+(numFoundPrevWeek - numFoundWeek)+' '+this.props.getValue('LESS')+" "+this.props.getValue('THAN_THE_PREVIOUS_WEEK');
    }

    getIsPrevLess = (numFoundWeek, numFoundPrevWeek) => {
        return numFoundWeek > numFoundPrevWeek;
    }

    getDocsTitleByCount = (documentsCount) => {
        let lastNum = Math.abs(documentsCount) % 10;
        if( lastNum < 5 && lastNum !== 0){
            return 'документа'
        }
        else return 'документов'
    }

    getNumPreviousWeek = (sentiment) => {
        switch(sentiment){
            case 'POSITIVE':
                return this.props.data.numFoundPositivePrevWeek;
            case 'NEGATIVE':
                return this.props.data.numFoundNegativePrevWeek;
            case 'NEUTRAL':
                return this.props.data.numFoundNeutralPrevWeek;
            default:
                return this.props.data.numFoundPrevWeek;
                
        }
    }

    getNumWeek = (sentiment) => {
        switch(sentiment){
            case 'POSITIVE':
                return this.props.data.numFoundPositiveWeek;
            case 'NEGATIVE':
                return this.props.data.numFoundNegativeWeek;
            case 'NEUTRAL':
                return this.props.data.numFoundNeutralWeek;
            default:
                return this.props.data.numFoundWeek;
                
        }
    }

    getTitleByLanguage = (sentiment = '') => {
        let sentimentText = sentiment ? this.props.getValue('WITH_'+sentiment+'_TONE').toLowerCase() : '';
        let previous = this.getNumPreviousWeek(sentiment);
        let num = this.getNumWeek(sentiment);
        let isPrevLess = this.getIsPrevLess(num, previous);
        let documentsCount =  isPrevLess ? num - previous : previous - num;
        let result = ``;
        switch(this.props.language){
            case 'RUS':    
                result = `За эту неделю было собрано ${num} ${this.getDocsTitleByCount(num)} ${sentimentText} с ${moment().startOf('isoWeek').format("DD-MM-YYYY")} по ${moment().format("DD-MM-YYYY")}\n`+
                `На прошлой недели было собрано ${previous} ${this.getDocsTitleByCount(previous)} ${sentimentText} с ${moment().subtract(1, 'week').startOf('isoWeek').format("DD-MM-YYYY")} по ${moment().subtract(1, 'week').format("DD-MM-YYYY")}\n`+
                `Документов собрано на ${ documentsCount } ${this.getIsPrevLess(num, previous) ? 'больше' : 'меньше'} чем на прошлой недели`;
                return result;
            case 'ENG':
                result = `In this week ${num} documents ${sentimentText} was collected on ${moment().startOf('isoWeek').format("DD-MM-YYYY")} by ${moment().format("DD-MM-YYYY")} \n`+
                `In previous week ${previous} documents ${sentimentText} was collected on ${moment().subtract(1, 'week').startOf('isoWeek').format("DD-MM-YYYY")} by ${moment().subtract(1, 'week').format("DD-MM-YYYY")} \n`+
                `The documnents was collected ${documentsCount} ${this.getIsPrevLess(num, previous) ? 'more' : 'less'} than the last week`;
                return result;
            case 'KAZ':
                result = `Осы аптада ${num} ${sentimentText} құжат жиналған ${moment().startOf('isoWeek').format("DD-MM-YYYY")} бастап ${moment().format("DD-MM-YYYY")} дейін\n`+
                `Өткен аптада ${previous} ${sentimentText} құжат жиналған ${moment().subtract(1, 'week').startOf('isoWeek').format("DD-MM-YYYY")} бастап ${moment().subtract(1, 'week').format("DD-MM-YYYY")} дейін\n`+
                `Жиналған құжаттар өткен аптамен салыстырғанда ${ documentsCount } құжатқа ${this.getIsPrevLess(num, previous) ? 'көп' : 'аз'}`;
                return result;
        }   
    }

    render(){
        return (this.props.data && this.props.data.topicId) ? (this.props.deviceType !== 'mobile'
            ? <ShortAnalyticChartItem {...this.props} getFormattedCount={this.getFormattedCount} getArrowByValues={this.getArrowByValues} getTitleByLanguage={this.getTitleByLanguage}/> 
            : <ShortAnalyticMobileChartItem {...this.props} getFormattedCount={this.getFormattedCount} getArrowByValues={this.getArrowByValues}/>) : <div className="AnalyticItem"></div>
    }

}

export default ShortAnlayticChartItemController;